class RteContent extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('a[title] > img').forEach(imgElement => {
      const aElement = imgElement.parentNode;
      if (aElement.title) {
        const buttonElement = document.createElement('SPAN');
        buttonElement.classList.add('Rte_ImageButton', 'Button');
        buttonElement.textContent = aElement.title;
        aElement.appendChild(buttonElement);
      }
    })
  }  
}

customElements.define("rte-content", RteContent);
